export default __webpack_public_path__ + "static/media/laptop13.3565cfe9.jpeg";